// SoporteDistribuidor.jsx
export default function SoporteDistribuidor() {
  return <div>Vista: Soporte Distribuidor</div>;
}
